<template>
  <div class="uren-login-register_area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6 m-auto col-xs-12">
            <form action="#">
              <div class="login-form">
                <h4 class="login-title">Register</h4>
                <div class="row">
                  <div class="col-md-6 col-12 mb--20">
                    <label>First Name</label>
                    <input v-model="firstName" type="text" placeholder="First Name">
                  </div>
                  <div class="col-md-6 col-12 mb--20">
                    <label>Last Name</label>
                    <input v-model="lastName" type="text" placeholder="Last Name">
                  </div>
                  <div class="col-md-6 col-12 mb--20 ">
                    <label>Email Address*</label>
                    <input v-model="email" type="email" placeholder="Email Address">
                  </div>
                  <div class="col-md-6">
                    <label>Password</label>
                    <input v-model="password" type="password" placeholder="Password">
                  </div>
                  <div class="col-md-6">
                    <label>Confirm Password</label>
                    <input v-model="confirmPassword" type="password" placeholder="Confirm Password">
                  </div>
                  <div class="forgotton-password_info col-12">
                     Already have an account? <router-link to="/login">Login</router-link>
                    </div>
                  
                  <div class="col-12">
                    <button class="uren-register_btn">Register</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
    }
  }
}
</script>

<style>

</style>
